import { apiGet } from "../utils/server-utils";
import { HydraCollection, HydraMember } from "../utils/hydra-utils";

export const fetchUnitSystems = () =>
  apiGet<HydraCollection<{ label: string, isDefault: boolean } & HydraMember>>(
    "/unit_systems"
  ).then(response => response.data["hydra:member"]);
